import * as ethers from 'ethers'

// DeepLink智能合约ABI
const CONTRACT_ABI = [
  {
    "inputs": [],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "uint256",
        "name": "id",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "string",
        "name": "title",
        "type": "string"
      },
      {
        "indexed": false,
        "internalType": "string",
        "name": "author",
        "type": "string"
      },
      {
        "indexed": false,
        "internalType": "string",
        "name": "category",
        "type": "string"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "timestamp",
        "type": "uint256"
      }
    ],
    "name": "NewsCreated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "uint256",
        "name": "id",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "string",
        "name": "name",
        "type": "string"
      },
      {
        "indexed": false,
        "internalType": "string",
        "name": "email",
        "type": "string"
      },
      {
        "indexed": false,
        "internalType": "string",
        "name": "subject",
        "type": "string"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "timestamp",
        "type": "uint256"
      }
    ],
    "name": "ContactCreated",
    "type": "event"
  },
  {
    "inputs": [
      {
        "internalType": "string",
        "name": "_name",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_email",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_phone",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_subject",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_message",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_department",
        "type": "string"
      }
    ],
    "name": "createContact",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "string",
        "name": "_title",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_content",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_author",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_category",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_imageUrl",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_summary",
        "type": "string"
      },
      {
        "internalType": "bool",
        "name": "_published",
        "type": "bool"
      },
      {
        "internalType": "bool",
        "name": "_featured",
        "type": "bool"
      }
    ],
    "name": "createNews",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getAllNews",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "id",
            "type": "uint256"
          },
          {
            "internalType": "string",
            "name": "title",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "content",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "author",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "category",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "imageUrl",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "summary",
            "type": "string"
          },
          {
            "internalType": "bool",
            "name": "published",
            "type": "bool"
          },
          {
            "internalType": "bool",
            "name": "featured",
            "type": "bool"
          },
          {
            "internalType": "uint256",
            "name": "publishedAt",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "createdAt",
            "type": "uint256"
          }
        ],
        "internalType": "struct DeepLinkContract.News[]",
        "name": "",
        "type": "tuple[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getStats",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "_newsCount",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_careerCount",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_productCount",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_solutionCount",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_contactCount",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "owner",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "paused",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  }
]

// 合约地址 (Sepolia测试网络)
const CONTRACT_ADDRESS = '0x5FbDB2315678afecb367f032d93F642f64180aa3' // DeepLink合约地址

// 稳定的RPC节点配置
const RPC_CONFIGS = [
  'https://sepolia.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161', // Infura Sepolia
  'https://rpc.sepolia.org', // 公共Sepolia节点
  'https://sepolia.gateway.tenderly.co', // Tenderly Sepolia
  'https://ethereum-sepolia.publicnode.com', // PublicNode Sepolia
]

// 获取可用的RPC URL
const getRpcUrl = () => {
  const customRpc = (import.meta as any).env?.VITE_RPC_URL
  if (customRpc) return customRpc
  
  // 使用第一个稳定的节点
  return RPC_CONFIGS[0]
}

const RPC_URL = getRpcUrl()

class BlockchainService {
  private provider: ethers.JsonRpcProvider
  private contract: ethers.Contract
  private signer: ethers.Signer | null = null

  constructor() {
    try {
      this.provider = new ethers.JsonRpcProvider(RPC_URL)
      this.contract = new ethers.Contract(CONTRACT_ADDRESS, CONTRACT_ABI, this.provider)
      console.log('✅ 区块链服务初始化成功')
      console.log('🌐 使用RPC节点:', RPC_URL)
      console.log('📍 合约地址:', CONTRACT_ADDRESS)
      
      // 异步检查RPC健康状态
      this.checkRpcHealth().catch(() => {
        console.log('🔄 主RPC节点不可用，尝试备用节点...')
        this.switchToBackupRpc()
      })
    } catch (error) {
      console.error('❌ 区块链服务初始化失败:', error)
      throw error
    }
  }

  // 连接钱包
  async connectWallet() {
    try {
      // 检查是否在浏览器环境中
      if (typeof window === 'undefined') {
        throw new Error('此功能仅在浏览器环境中可用')
      }

      // 检查MetaMask是否已安装
      if (typeof window.ethereum === 'undefined') {
        throw new Error('请安装MetaMask钱包')
      }

      // 检查MetaMask是否可用
      if (!window.ethereum.isMetaMask) {
        throw new Error('请确保使用MetaMask钱包')
      }

      // 请求连接钱包
      const accounts = await window.ethereum.request({ 
        method: 'eth_requestAccounts' 
      })

      if (!accounts || accounts.length === 0) {
        throw new Error('用户拒绝了连接请求')
      }

      // 创建provider和signer
      const provider = new ethers.BrowserProvider(window.ethereum)
      this.signer = await provider.getSigner()
      this.contract = this.contract.connect(this.signer) as ethers.Contract
      
      return true
    } catch (error) {
      console.error('连接钱包失败:', error)
      // 提供更友好的错误信息
      if ((error as any).code === 4001) {
        throw new Error('用户拒绝了连接请求')
      } else if ((error as any).code === -32002) {
        throw new Error('连接请求已在进行中，请检查MetaMask')
      } else {
        throw new Error(`连接钱包失败: ${(error as Error).message}`)
      }
    }
  }

  // 检查是否已连接钱包
  async isConnected() {
    try {
      if (typeof window.ethereum !== 'undefined') {
        const accounts = await window.ethereum.request({ method: 'eth_accounts' })
        return accounts.length > 0
      }
      return false
    } catch (error) {
      console.error('检查钱包连接状态失败:', error)
      return false
    }
  }

  // 检查RPC节点健康状态
  async checkRpcHealth() {
    try {
      const blockNumber = await this.provider.getBlockNumber()
      console.log('✅ RPC节点健康检查通过，当前区块:', blockNumber)
      return true
    } catch (error) {
      console.error('❌ RPC节点健康检查失败:', error)
      return false
    }
  }

  // 切换到备用RPC节点
  async switchToBackupRpc() {
    try {
      for (let i = 1; i < RPC_CONFIGS.length; i++) {
        const backupUrl = RPC_CONFIGS[i]
        console.log(`🔄 尝试备用RPC节点: ${backupUrl}`)
        
        const backupProvider = new ethers.JsonRpcProvider(backupUrl)
        const blockNumber = await backupProvider.getBlockNumber()
        
        if (blockNumber) {
          this.provider = backupProvider
          this.contract = new ethers.Contract(CONTRACT_ADDRESS, CONTRACT_ABI, this.provider)
          console.log(`✅ 成功切换到备用RPC节点: ${backupUrl}`)
          return true
        }
      }
      throw new Error('所有RPC节点都不可用')
    } catch (error) {
      console.error('❌ 切换备用RPC节点失败:', error)
      return false
    }
  }

  // 创建联系表单到区块链
  async createContactOnChain(contactData: {
    name: string
    email: string
    phone: string
    message: string
    subject: string
    department: string
  }) {
    try {
      if (!this.signer) {
        await this.connectWallet()
      }

      const tx = await this.contract.createContact(
        contactData.name,
        contactData.email,
        contactData.phone,
        contactData.subject,
        contactData.message,
        contactData.department
      )

      const receipt = await tx.wait()
      return {
        success: true,
        txHash: receipt.hash,
        blockNumber: receipt.blockNumber
      }
    } catch (error) {
      console.error('创建联系表单到区块链失败:', error)
      throw error
    }
  }

  // 创建新闻到区块链
  async createNewsOnChain(newsData: {
    title: string
    content: string
    author: string
    category: string
    imageUrl?: string
    summary?: string
    published?: boolean
    featured?: boolean
  }) {
    try {
      if (!this.signer) {
        await this.connectWallet()
      }

      const tx = await this.contract.createNews(
        newsData.title,
        newsData.content,
        newsData.author,
        newsData.category,
        newsData.imageUrl || '',
        newsData.summary || '',
        newsData.published || false,
        newsData.featured || false
      )

      const receipt = await tx.wait()
      return {
        success: true,
        txHash: receipt.hash,
        blockNumber: receipt.blockNumber
      }
    } catch (error) {
      console.error('创建新闻到区块链失败:', error)
      throw error
    }
  }

  // 从区块链获取新闻
  async getNewsFromChain() {
    try {
      const news = await this.contract.getAllNews()
      return news.map((item: any) => ({
        _id: item.id.toString(),
        title: item.title,
        content: item.content,
        author: item.author,
        category: item.category,
        imageUrl: item.imageUrl,
        summary: item.summary,
        published: item.published,
        featured: item.featured,
        publishedAt: new Date(Number(item.publishedAt) * 1000),
        createdAt: new Date(Number(item.createdAt) * 1000)
      }))
    } catch (error) {
      console.error('从区块链获取新闻失败:', error)
      return []
    }
  }

  // 获取合约统计信息
  async getContractStats() {
    try {
      const stats = await this.contract.getStats()
      return {
        newsCount: Number(stats[0]),
        careerCount: Number(stats[1]),
        productCount: Number(stats[2]),
        solutionCount: Number(stats[3]),
        contactCount: Number(stats[4])
      }
    } catch (error) {
      console.error('获取合约统计信息失败:', error)
      return null
    }
  }

  // 获取网络信息
  async getNetworkInfo() {
    try {
      const network = await this.provider.getNetwork()
      return {
        name: network.name,
        chainId: network.chainId,
        ensAddress: (network as any).ensAddress || null
      }
    } catch (error) {
      console.error('获取网络信息失败:', error)
      return null
    }
  }
}

// 扩展Window接口以支持ethereum
declare global {
  interface Window {
    ethereum?: any
  }
}

export default new BlockchainService()